export default __webpack_public_path__ + "static/media/elevate-bpn-poster-1.3200047f.jpg";